import moment from "moment";
import { protocols, pathologies } from "./constants";
// Assets
import AvatarBlue from "../assets/avatar_blue.svg";

export const getAge = (birthDateParam) => {
  const today = new Date();
  const birthDate = new Date(birthDateParam);
  const m = today.getMonth() - birthDate.getMonth();
  let age = today.getFullYear() - birthDate.getFullYear();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

export const passwordValidation = (password) => {
  const regExp = /^(?=.{8,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!<>#$%&"'()*+,-./@?])/;
  return regExp.test(password);
};

export const dateValidation = (date) => {
  const day = date.split("/")[0];
  const month = Number(date.split("/")[1]) - 1;
  const year = date.split("/")[2];
  const dateParsed = new Date(year, month, day);
  const dateValidate = moment(date, "DD/MM/YYYY", true).isValid();

  const age = moment().diff(date, "years");
  const limitedAge = 120;

  if (!dateValidate || dateParsed > new Date()) {
    return false;
  }

  if (age > limitedAge) {
    return false;
  }
  return true;
};

export const parsedDate = (date) => {
  const day = date.split("/")[0];
  const month = Number(date.split("/")[1]) - 1;
  const year = date.split("/")[2];
  return new Date(year, month, day, 12, 0, 0);
};

export const parseSecondsToMinutes = (seconds) => {
  return Number(seconds) / 60;
};

export const handleSetDurationFromDB = (prescription) => {
  const secondsPerMinute = 60;
  return prescription.SESSION_DURATION / secondsPerMinute;
};

export const HeightValidation = (height) => {
  if (height >= 100 && height <= 230) {
    return true;
  } else {
    return false;
  }
};

export const renderAffectations = (t) => {
  return (
    <>
      <option value=""></option>
      <option value={pathologies.otherId}>{t("patientPathology.other")}</option>
      <option value={pathologies.alzheimerId}>{t("patientPathology.alzheimer")}</option>
      <option value={pathologies.ataxiaId}>{t("patientPathology.ataxia")}</option>
      <option value={pathologies.cerebralPalsyId}>{t("patientPathology.cerebralPalsy")}</option>
      <option value={pathologies.multipleSclerosisId}>{t("patientPathology.multipleSclerosis")}</option>
      <option value={pathologies.parkinsonId}>{t("patientPathology.parkinson")}</option>
      <option value={pathologies.spinalCordInjuryId}>{t("patientPathology.spinalCordInjury")}</option>
      <option value={pathologies.strokeId}>{t("patientPathology.stroke")}</option>
      <option value={pathologies.traumaticBrainInjuryId}>{t("patientPathology.traumaticBrainInjury")}</option>
      <option value={pathologies.amputationId}>{t("patientPathology.amputation")}</option>
    </>
  );
};

export const isOnlyProtocolWithScore = (protocolId) => {
  const basicProtocols = Object.values(protocols.app.basic);
  const tensorFlowProtocols = Object.values(protocols.app.tensorFlow);
  const arProtocols = Object.values(protocols.app.ar);
  const webProtocols = Object.values(protocols.web);
  const allProtocols = basicProtocols.concat(tensorFlowProtocols, arProtocols, webProtocols);
  let allProtocolsId = [];
  allProtocols.forEach((protocol) => {
    allProtocolsId.push(protocol.id);
  });
  return (
    Number(protocolId) === protocols.clinicAndHome.BUBBLES.id ||
    Number(protocolId) === protocols.clinicAndHome.DEMOLITION.id ||
    allProtocolsId.includes(Number(protocolId))
  );
};

export const isARProtocol = (protocolId) => {
  const arProtocols = Object.values(protocols.app.ar);
  let arProtocolsId = [];
  arProtocols.forEach((protocol) => {
    arProtocolsId.push(protocol.id);
  });
  return arProtocolsId.includes(Number(protocolId));
};

export const fillAllSessions = (data, currentPositions, currentValues, valueToFill) => {
  let sessionsId = [];
  data.forEach((recording) => {
    if (!sessionsId.includes(recording.SESSION_ID)) {
      sessionsId.push(recording.SESSION_ID);
    }
  });
  sessionsId.forEach((_, sessionIndex) => {
    currentPositions.push(sessionIndex + 1);
    if (currentValues.length < sessionsId.length) {
      currentValues.unshift(valueToFill);
    }
  });
};
export const handleSetReports = (data, key, setPositions, setValues) => {
  const reports = data.filter((report) => report.RECORDING_KEY === key);
  if (reports.length > 0) {
    let currentPositions = [];
    let currentValues = [];
    reports.forEach((report) => {
      currentValues.push(report.RECORDING_VALUE);
    });
    fillAllSessions(data, currentPositions, currentValues, NaN);
    setPositions(currentPositions);
    setValues(currentValues);
  } else {
    setPositions([]);
    setValues([]);
  }
};
export const handleSetMetric = (data, key, setPositions, setValues, sessionsId) => {
  const reports = data.filter((report) => report.METRIC_KEY === key);
  if (reports.length > 0) {
    let currentPositions = [];
    let currentValues = [];
    reports.forEach((report) => {
      currentValues.push(report.METRIC_VALUE);
    });
    sessionsId.forEach((_, sessionIndex) => {
      currentPositions.push(sessionIndex + 1);
      if (currentValues.length < sessionsId.length) {
        currentValues.unshift("");
      }
    });
    setPositions(currentPositions);
    setValues(currentValues);
  } else {
    setPositions([]);
    setValues([]);
  }
};

export const handleSetPrescribedSessionDuration = (data, setPositions, setValues) => {
  const reports = data.filter((report) => report.RECORDING_KEY === "score");
  if (reports.length > 0) {
    let currentPositions = [];
    let currentValues = [];
    reports.forEach((report) => {
      currentValues.push(report.SESSION_DURATION / 60);
    });
    fillAllSessions(data, currentPositions, currentValues, NaN);
    setPositions(currentPositions);
    setValues(currentValues);
  } else {
    setPositions([]);
    setValues([]);
  }
};
export const handleSetTrainedSessionDuration = (data, setPositions, setValues) => {
  const reports = data.filter((session) => session.RECORDING_KEY === "sessionDuration(seconds)");
  if (reports.length > 0) {
    let currentPositions = [];
    let currentValues = [];
    reports.forEach((session) => {
      let trainedMinutes = (Number(session.RECORDING_VALUE) / 60).toFixed(2);
      currentValues.push(trainedMinutes);
    });
    fillAllSessions(data, currentPositions, currentValues, NaN);
    setPositions(currentPositions);
    setValues(currentValues);
  } else {
    setPositions([]);
    setValues([]);
  }
};

export const getProtocolTitle = (protocolId, t) => {
  switch (Number(protocolId)) {
    // Clinic and Home
    case protocols.clinicAndHome.TOWERS.id:
      return t("protocols.towers");
    case protocols.clinicAndHome.BALLOONS.id:
      return t("protocols.balloons");
    case protocols.clinicAndHome.CALIBRATION.id:
      return t("protocols.calibration");
    case protocols.clinicAndHome.RUNNER.id:
      return t("protocols.runner");
    case protocols.clinicAndHome.DATA_COLLECTION.id:
      return t("protocols.dataCollection");
    case protocols.clinicAndHome.PRACTICE.id:
      return t("protocols.practice");
    default:
      break;
  }
};

export const getProtocolReportTitle = (protocolId, t) => {
  switch (Number(protocolId)) {
    // Clinic and Home
    case protocols.clinicAndHome.TOWERS.id:
      return t("uppercaseProtocols.towers");
    case protocols.clinicAndHome.BALLOONS.id:
      return t("uppercaseProtocols.balloons");
    case protocols.clinicAndHome.CALIBRATION.id:
      return t("uppercaseProtocols.calibration");
    case protocols.clinicAndHome.RUNNER.id:
      return t("uppercaseProtocols.runner");
    case protocols.clinicAndHome.DATA_COLLECTION.id:
      return t("uppercaseProtocols.dataCollection");
    case protocols.clinicAndHome.PRACTICE.id:
      return t("uppercaseProtocols.practice");
    default:
      break;
  }
};

export const renderAvatar = (isThereSomePrescription, isTherePrescriptionsAfter7Days, adherence) => {
  return AvatarBlue;
};

export const handleSetProtocolsCategory = (protocolsCategory, orderedProtocolsCategory, hospitalProtocols) => {
  return protocolsCategory.forEach((protocol) => {
    if (hospitalProtocols.includes(protocol.id) && protocol.isActive) {
      orderedProtocolsCategory.push(protocol.id);
    }
  });
};

export const getTrainedMinutesAndSeconds = (trainedSeconds) => {
  const minutes = Math.floor(trainedSeconds / 60);
  const seconds = trainedSeconds - minutes * 60;
  return `${minutes}’ ${seconds}’’`;
};

export const isProtocolWithDetails = (protocolId) => {
  return Number(protocolId) === protocols.clinicAndHome.CALIBRATION.id;
};

export const isProtocolWithoutDuration = (protocolId) => {
  return Number(protocolId) === protocols.clinicAndHome.CALIBRATION.id;
};

export const getRandomColor = () => {
  const r = Math.floor(Math.random() * 255);
  const g = Math.floor(Math.random() * 255);
  const b = Math.floor(Math.random() * 255);
  return `rgba(${r}, ${g}, ${b}, 1)`;
};
